import { createFileRoute, redirect } from '@tanstack/react-router';
import { fallback, zodSearchValidator } from '@tanstack/router-zod-adapter';
import z from 'zod';

import { Role } from '../../types/Role';
import { TokenManager } from '../auth/TokenManager';
import { queries } from '../common/api/queryKeys/queries';
import { SupplierGroupDetailPage } from '../group/supplier/detail/SupplierGroupDetailPage';
import { SupplierGroupTabs } from '../group/supplier/SupplierGroupTabs';
import { SessionService } from '../user/session/SessionService';

const supplierGroupDetailSearchSchema = z.object({
    tab: fallback(
        z.enum([
            SupplierGroupTabs.DETAILS,
            SupplierGroupTabs.SPOT_PORT_AVAILABILITY,
            SupplierGroupTabs.TWO_STEP_AUTH,
            SupplierGroupTabs.SSO,
            SupplierGroupTabs.DEVELOPERS,
            SupplierGroupTabs.SURCHARGES,
        ]),
        SupplierGroupTabs.DETAILS
    ).default(SupplierGroupTabs.DETAILS),
});

export const Route = createFileRoute('/_app/supplier-groups/$groupId/')({
    component: SupplierGroupDetailPage,
    validateSearch: zodSearchValidator(supplierGroupDetailSearchSchema),
    beforeLoad: async ({ context }) => {
        const token = await TokenManager.getInstance().getToken();
        const role = await context.queryClient.ensureQueryData<Role>({
            queryKey: queries.role.information.queryKey,
            queryFn: () => SessionService.getInstance().loadRoleInformation(token),
        });

        if (!role.hasAdminRights()) {
            throw redirect({ to: '/settings' });
        }
    },
    async loader({ params, context }) {
        return Promise.all([
            context.queryClient.ensureQueryData(queries.supplierGroups.detail(params.groupId)),
            context.queryClient.prefetchQuery(queries.suppliers.list({ groupId: params.groupId })),
        ]);
    },
});
